import { Component } from '@angular/core';

type TemplateStatus = 'draft' | 'published';

type TriggerType = 'task_start' | 'task_stagnation' | 'task_overdue';

type DeliveryStatus = 'queued' | 'sent' | 'failed';

interface TemplateRow {
  name: string;
  taskType: string;
  status: TemplateStatus;
  version: string;
  variants: number;
  isSystem?: boolean;
}

interface AutomationRow {
  stage: string;
  task: string;
  start: boolean;
  stagnation: boolean;
  overdue: boolean;
}

interface AuditRow {
  sentAt: string;
  project: string;
  task: string;
  recipient: string;
  channel: string;
  template: string;
  variant: number;
  status: DeliveryStatus;
  manualOverride?: boolean;
}

interface AiSuggestion {
  title: string;
  summary: string;
  actions: string[];
}

@Component({
  selector: 'app-notification-automation',
  templateUrl: './notification-automation.component.html',
  styleUrls: ['./notification-automation.component.css']
})
export class NotificationAutomationComponent {
  statusFilters: TemplateStatus[] = ['draft', 'published'];
  triggerFilters: TriggerType[] = ['task_start', 'task_stagnation', 'task_overdue'];
  logsStatusFilters: DeliveryStatus[] = ['queued', 'sent', 'failed'];

  templates: TemplateRow[] = [
    { name: 'Stagnation Nudge', taskType: 'employee_upload', status: 'published', version: '1.0', variants: 3 },
    { name: 'Welcome Kickoff', taskType: 'kickoff', status: 'draft', version: '0.2', variants: 1 },
    { name: 'Overdue Escalation', taskType: 'data_validation', status: 'published', version: '1.1', variants: 2, isSystem: true },
  ];

  coverage: AutomationRow[] = [
    { stage: 'Discovery', task: 'Employee Upload', start: true, stagnation: true, overdue: false },
    { stage: 'Configuration', task: 'Benefits Setup', start: true, stagnation: false, overdue: false },
    { stage: 'Validation', task: 'Data QA', start: true, stagnation: true, overdue: true },
  ];

  audit: AuditRow[] = [
    { sentAt: '2026-01-06T08:30:05Z', project: 'proj_123', task: 'Employee Upload', recipient: 'alice@example.com', channel: 'email', template: 'Stagnation Nudge', variant: 2, status: 'sent' },
    { sentAt: '2026-01-06T07:05:00Z', project: 'proj_123', task: 'Welcome', recipient: 'bob@example.com', channel: 'web_push', template: 'Welcome Kickoff', variant: 1, status: 'queued' },
    { sentAt: '2026-01-05T16:10:11Z', project: 'proj_456', task: 'Data QA', recipient: 'maria@example.com', channel: 'email', template: 'Overdue Escalation', variant: 1, status: 'failed', manualOverride: true },
  ];

  aiSuggestions: AiSuggestion[] = [
    {
      title: 'Automation for Employee Upload',
      summary: 'Start + stagnation + overdue with progressive nudges',
      actions: ['Send welcome email on task_start', 'Send educational nudge at day 3', 'Send urgent escalation at deadline']
    },
    {
      title: 'Automation for Data QA',
      summary: 'Stagnation emphasis with supportive tone',
      actions: ['Send supportive nudge at day 4', 'Escalate to consultant at day 7']
    }
  ];
}
